import type { FaireReviewEntity } from "../../entity_types/review";

export const review_r5: FaireReviewEntity = {
  token: "review_r5",
  type: "review",
  brandName: "ROEN",
  reviewerName: "Lisa T.",
  reviewerLocation: "Chicago, IL",
  stars: 5,
  reviewText:
    "Love the clean ingredients and the elegant packaging. These make great gifts and my holiday sales were through the roof.",
  reviewDate: "Nov 28, 2025",
  reviewType: "brand",
  purchasedProductImageUrls: [
    "https://cdn.prerelease.faire.dev/fastly/56884e66685193058ffed10b4132877eba11d2a0013a35e2fa68ec6fad9c8ed6.webp",
    "https://cdn.prerelease.faire.dev/fastly/59a4005712dbc289690cccb048ed1838bfbb32630127b5ae4ce805f9204e0b93.webp",
    "https://cdn.prerelease.faire.dev/fastly/a15d1fc087908754991b018a69774258782ff3fad6f50ef4078fe96c26a1caf6.webp",
  ],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
